module.exports = __webpack_public_path__ + "img/about__culture-img——vi.4638e0ac.png";